import { Bell, Shield } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";

const PrivateRepo = () => {
  return (
    <section className="py-24 px-6 relative overflow-hidden">
      {/* Background glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-primary/5 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto max-w-4xl relative z-10">
        <div className="landing-glass rounded-2xl p-8 md:p-12 text-center landing-glow-primary">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-6">
            <Shield className="w-4 h-4 text-primary" />
            <span className="text-sm font-medium text-primary">Premium Access</span>
          </div>

          <h2 className="text-2xl md:text-4xl font-serif font-semibold text-foreground mb-4">
            Unlock personalized concierge services
          </h2>
          
          <p className="text-muted-foreground max-w-2xl mx-auto mb-8 text-lg">
            Get priority support and a dedicated AI assistant that supports you throughout your work day.
            Experience your Kiln membership like never before.
          </p>

          <Button variant="hero" size="lg" className="gap-2" asChild>
            <Link to="/login">
              <Bell className="w-4 h-4" />
              Join the waitlist
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default PrivateRepo;
